export const required = value => (value ? undefined : 'Required');
export const email = value =>
value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
? 'Invalid email address'
: undefined;
export const nonEmpty = value =>
value.trim() !== '' ? undefined : 'Cannot be empty';
export const isTrimmed = value =>
value.trim() === value ? undefined : 'Cannot start or end with whitespace';
export const maxLength = max => value =>
value && value.length > max ? `Must be ${max} characters or less` : undefined
export const maxLength15 = maxLength(15)
export const minLength = min => value =>
value && value.length < min ? `Must be ${min} characters or more` : undefined
export const minLength6 = minLength(6)

export const alphaNumeric = value =>
value && /[^a-zA-Z0-9 ]/i.test(value)
? 'Only alphanumeric characters'
: undefined

export const matches = field => (value, allValues) =>
field in allValues && value.trim() === allValues[field].trim()
? undefined
: 'Does not match';



// WEBPACK FOOTER //
// ./src/helpers/validators.js